import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import { FormFieldTime } from '@/global/components/Form'
import IconeAjuda from '@/global/components/IconeAjuda'
import Grid from '@/global/components/ui/Grid'

export default function InterjornadaForm() {
    return (
        <Grid container>
            <Grid item xs={24} className="mb-4 mt-8">
                <HorizontalDivider>Interjornada</HorizontalDivider>
            </Grid>
            <Grid item xs={6}>
                <FormFieldTime
                    name="horasIntervalares"
                    label="Horas intervalares"
                    placeholder="HH:mm"
                    endAdornment={
                        <IconeAjuda>
                            Esse campo determina quantas horas intervalares vão
                            ser concedidas ao funcionário sempre que ele
                            trabalhar no dia.
                            <br />
                            <br />
                            As horas intervalares serão exibidas no espelho do
                            ponto e na integração com a folha de pagamento.
                            <br />
                            <br />
                            Deixe em branco para não considerar horas
                            intervalares.
                        </IconeAjuda>
                    }
                    autoComplete="off"
                />
            </Grid>
        </Grid>
    )
}
